export default "__VITE_ASSET__CXzdK_mv__"